/** Map the widget's internal FilterNode[] tree to the backend wire AST. */
import type { FilterNode, WireNode } from './types';

function toWireNode(node: FilterNode): WireNode {
  switch (node.kind) {
    case 'cond':
      return {
        namespace: node.namespace,
        // `idmatch` is a FE-only node operator (the `=#` match-by-id sigil); on
        // the wire it is the backend's `exact` operator, which each namespace's
        // compiler interprets as a row-id lookup.
        operator: node.operator === 'idmatch' ? 'exact' : node.operator,
        value: node.value,
        ...(node.not ? { not: true } : {}),
        ...(node.scope === 'all' ? { scope: 'all' as const } : {}),
      };
    case 'freetext':
      return {
        namespace: '__freetext',
        value: node.value,
        ...(node.not ? { not: true } : {}),
      };
    case 'group':
      return {
        namespace: node.op,
        conditions: node.children.map(toWireNode),
        ...(node.not ? { not: true } : {}),
      };
  }
}

/** Top-level: element-wise mapping (array in, array out). */
export function toWireAst(nodes: FilterNode[]): WireNode[] {
  return nodes.map(toWireNode);
}
